import React from 'react';
import { connect } from 'react-redux';
import { hasRequiredScope } from 'utils/scope';

interface IOwnProps {
  requiredScope?: string;
  children: JSX.Element;
  // Indexer
  passedProps?: { [key: string]: any };
}

interface IStateProps {
  currentUserScopes: string[];
}

export type AuthorizationComponentType = IStateProps & IOwnProps;

const AuthorizationComponent = ({
  requiredScope,
  currentUserScopes,
  children,
  passedProps,
}: AuthorizationComponentType) => {
  if (
    requiredScope &&
    hasRequiredScope(currentUserScopes)(requiredScope) === false
  )
    return null;
  return React.cloneElement(children, { ...passedProps });
};

const mapStateToProps = ({
  authenticate,
}: {
  authenticate: IAuthenticateState;
}) => ({
  currentUserScopes: authenticate?.profile?.scopes ?? [],
});

export default connect(mapStateToProps)(AuthorizationComponent);
